<template>
  <v-layout>
    <v-flex xs12>
      <v-card class="elevation-3 px-2">
        <v-container>
          <v-layout row wrap>
            <v-autocomplete
              dense
              chips
              hide-details
              hide-selected
              multiple
              label="Пункты доставки"
              placeholder="Выберите пункты доставки, для которых будет формироваться заказ"
              ref="points"
              item-text="address"
              item-value="pointId"
              :value="selectedPoints"
              :items="points"
              @change="(item) => addPoints(item)"
              class="py-2"
            >
              <template v-slot:selection="data">
                <v-chip
                  close
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  @click="data.select"
                  @click:close="removePoint(data.item)"
                >
                  <v-icon left color="primary">{{ icons.mapMarker }}</v-icon>
                  {{ data.item.address }}
                </v-chip>
              </template>
              <template v-slot:item="data">
                <template v-if="typeof data.item !== 'object'">
                  <v-list-item-content v-text="data.item"></v-list-item-content>
                </template>
                <template v-else>
                  <v-list-item-avatar>
                    <v-icon color="primary">{{ icons.mapMarker }}</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title
                      v-html="data.item.address"
                    ></v-list-item-title>
                    <v-list-item-subtitle
                      v-html="data.item.name"
                    ></v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </template>
            </v-autocomplete>
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { Icon } from "@/helpers";

export default {
  props: {
    points: Array,
    selectedPoints: Array,
  },
  methods: {
    addPoints: function (pointIds) {
      if (this.points && this.points != null && this.points.length > 0) {
        let currentPoints = this.points.filter((current) => {
          return pointIds.find((el) => {
            return el == current.pointId;
          });
        });
        this.$emit("add-points", currentPoints);

        if (this.$refs && this.$refs.points) {
          this.$refs.points.blur();
        }
      }
    },
    removePoint: function (item) {
      this.$emit("remove-point", item);
    },
  },
  data: () => ({
    icons: {
      mapMarker: Icon.mapMarker,
    },
  }),
};
</script>
